/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SulphitationTower } from "./modelSulphitationTower";

class ControllerSulphitationTower extends ControllerModel {
  constructor() {
    super("ControllerSulphitationTower");
    
    this.setNewNode = (callback) => {
      let sulphitationTower = new SulphitationTower();
      sulphitationTower.decorate(callback);

      this.addNode(sulphitationTower);
    }

    this.loadNode = (node, callback) => {
      let sulphitationTower = new SulphitationTower();
      sulphitationTower.copyFrom(node);
      sulphitationTower.decorate(callback);
      this.addNode(sulphitationTower)
    }

    this.getProperties = async (node) => {
      let n = new SulphitationTower();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new SulphitationTower();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerSulphitationTower };
